/* eslint-disable react/no-unknown-property */
import {
  ActionIcon,
  DetailStack,
  HStack,
  ICON_PENCIL_OUTLINE, ICON_TRASH_CAN_OUTLINE, SimpleTable,
} from '@doveit/bricks';
import React from 'react';
import DateViewer from '../../../components/date-viewer/DateViewer';
import { HRRecall, JobApplication } from '../../../providers/api/dtos';
import HRRecallAvatar from '../../components/hr-recall-avatar/HRRecallAvatar';
import DeleteHRCalendarEventAction from '../delete-hr-calendar-event/DeleteHRCalendarEvent';
import UpdateHRRecallStatus from '../update-hr-recall-status/UpdateHRRecallStatus';
import UpsertHRRecallAction from '../upsert-hr-recall-action/UpsertHRRecallAction';
import TextPreview from '../../../components/text-preview/TextPreview';

export interface ViewHRRecallTableRowProps extends React.AriaAttributes {
  hrRecall: HRRecall,
  jobApplication: JobApplication,
  canUpdate?: boolean,
  canDelete?: boolean,
  onUpdate?: (hrRecall: HRRecall) => void,
  onDelete?: (id: string) => void,
}

const ViewHRRecallTableRow: React.FC<ViewHRRecallTableRowProps> = ({
  hrRecall,
  jobApplication,
  canUpdate = false,
  canDelete = false,
  onUpdate,
  onDelete,
  ...rest
}) => (
  <SimpleTable.Row
    aria-label="Informazioni recall"
    {...rest}
  >
    <SimpleTable.Cell
      aria-label="Preview"
      width="10rem"
    >
      <HStack gap={100} wrap="nowrap">
        <HRRecallAvatar size="S" />
        <DetailStack label="Recall">
          <DateViewer
            stringDate={hrRecall.date}
            checkIfToday
            checkIfTomorrow
            withStrong
            withHour
          />
        </DetailStack>
      </HStack>
    </SimpleTable.Cell>

    {/** colspan 2 to align with ViewHRInterviewTableRow format */}
    <SimpleTable.Cell aria-label="Stato" colSpan={2}>
      <UpdateHRRecallStatus
        hrRecall={hrRecall}
        onSuccess={onUpdate}
        showAsBadge={!canUpdate}
      />
    </SimpleTable.Cell>

    <SimpleTable.Cell
      aria-label="Note"
    >
      {hrRecall.note && (
        <TextPreview text={hrRecall.note} />
      )}
    </SimpleTable.Cell>

    <SimpleTable.Cell
      aria-label="Azioni"
      align="right"
    >
      <HStack gap={75} wrap="nowrap">
        <UpsertHRRecallAction
          jobApplication={jobApplication}
          hrRecall={hrRecall}
          canUpdate={canUpdate}
          onSuccess={onUpdate}
        >
          {({ isSaving, openModal }) => (
            <ActionIcon
              aria-label="Modifica recall"
              label="Modifica"
              size="S"
              icon={{ path: ICON_PENCIL_OUTLINE }}
              onClick={openModal}
              loading={isSaving}
            />
          )}
        </UpsertHRRecallAction>

        {canDelete && (
          <DeleteHRCalendarEventAction
            hrCalendarEventId={hrRecall.id!}
            onSuccess={onDelete}
          >
            {({ isSaving, openModal }) => (
              <ActionIcon
                aria-label="Elimina recall"
                label="Elimina"
                size="S"
                icon={{ path: ICON_TRASH_CAN_OUTLINE }}
                onClick={openModal}
                loading={isSaving}
              />
            )}
          </DeleteHRCalendarEventAction>
        )}
      </HStack>
    </SimpleTable.Cell>
  </SimpleTable.Row>
);

export default ViewHRRecallTableRow;
